import {
  MpkCancel,
  MpkCancelApi,
  MpkRequest as MpkRequestGenerated,
  PripomienkovanieApi,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import MpkRequest from '../../model/pracovnyKrok/MpkRequest';
import Uuid from '../../model/Uuid';
import dateToString from '../../function/dateToString';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new PripomienkovanieApi(apiConfiguration(elegislativaPrefixPath));
const mpkCancelClient = new MpkCancelApi(apiConfiguration(elegislativaPrefixPath));

const map = (
  mpkRequest: MpkRequest,
): MpkRequestGenerated => ({
  skratene: mpkRequest.skratene,
  dovodSkratenia: mpkRequest.dovodSkratenia,
  durationDays: mpkRequest.durationDays || 0,
  startDate: mpkRequest.startDate ? dateToString(mpkRequest.startDate) : null,
  pripomienkovatelList: mpkRequest?.dalsiPripomienkovatelia?.map(pripomienkovatel => pripomienkovatel.uuid) || [],
});

export const startMpk = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  mpkRequest: MpkRequest,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const mpkRequestGenerated = map(mpkRequest);
  const { status } = await client.startMpk(
    type,
    year,
    index,
    pracovnyKrokId,
    mpkRequestGenerated,
    headers,
  );
  return {
    responseCode: status,
  };
};

const mapMpkCancel = (dovodZrusenia: string): MpkCancel => ({
  dovodZrusenia,
});

export const cancelMpk = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  dovodZrusenia: string,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await mpkCancelClient.cancelMpk(
    type,
    year,
    index,
    pracovnyKrokId,
    mapMpkCancel(dovodZrusenia),
    headers,
  );
  return {
    responseCode: status,
  };
};
